import { useState, useEffect } from "react";
import { FiMenu, FiX, FiChevronUp, FiChevronDown } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import Logo from '../images/akt-akt (2).png';
import Submenuone from "./Section/Submenu/submenuthree";
import AlternateLogo from "../images/akt-akt (2).png";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [openNestedSubmenu, setOpenNestedSubmenu] = useState(null);
  const [openThirdLevelSubmenu, setOpenThirdLevelSubmenu] = useState(null);
  const [openAkttools, setOpenAkttools] = useState(null);


  const alternateLogoRoutes = [
    '/division/structural-divisions',
    '/division/steel-pipes',
    '/division/valve-&-flanges',
  ];

  const location = useLocation();

  const isAlternateLogo =
    alternateLogoRoutes.includes(location.pathname);

  const closeNavbar = () => {
    setIsOpen(false);
    setOpenSubmenu(null);
    setOpenNestedSubmenu(null);
    setOpenAkttools(null);
    setOpenThirdLevelSubmenu(null);
  };

  const toggleSubmenu = (menu) => {
    setOpenSubmenu(openSubmenu === menu ? null : menu);
  };

  const toggleNestedSubmenu = (submenu) => {
    setOpenNestedSubmenu(openNestedSubmenu === submenu ? null : submenu);
  };

  const toggleNestedSubmenus = (submenu) => {
    setOpenAkttools(openAkttools === submenu ? null : submenu);
  };

  const toggleThirdLevelSubmenu = (submenu) => {
    setOpenThirdLevelSubmenu(openThirdLevelSubmenu === submenu ? null : submenu);
  }

  const isActive = (path) =>
    location.pathname === path ? "animate-bounce-custom font-[18px] text-gray-900" : "text-gray-800";

  const isActivem = (path) =>
    location.pathname === path ? "text-blue-500 font-semibold" : "text-white";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed left-0 right-0 md:left-6 md:right-6 top-0 bg-white z-50 rounded-none md:rounded-2xl shadow-lg transition-all duration-300 ${scrolled ? "md:mt-0" : "md:mt-2"
        }`}
    >
      <div className="flex justify-between items-center px-6 md:px-10 py-3">
        <div className="flex items-center h-full">
          <Link
            to="/"
            onClick={closeNavbar}
            className="h-10 px-4 md:px-14 flex items-center justify-center overflow-visible"
          >
            <img
              src={isAlternateLogo ? AlternateLogo : Logo}
              alt="AKT Logo"
              className={`object-contain ${isAlternateLogo ? 'h-8 w-auto md:h-14' : 'h-9 md:h-14'
                }`}
              style={{
                transform: 'scale(1.2)',
                transformOrigin: 'center',
              }}
            />
          </Link>
        </div>

        <div className="hidden md:flex space-x-6 lg:space-x-10 font-medium text-gray-800 text-sm lg:text-base">
          <Link to="/" className={`hover:text-gray-600 hover:animate-bounce-custom ${isActive("/")}`}>
            HOME
          </Link>
          <Submenuone />
          <Link to="/about-us" className={`hover:text-gray-600 hover:animate-bounce-custom ${isActive("/about-us")}`}>
            ABOUT US
          </Link>
          <Link to="/media" className={`hover:text-gray-600 hover:animate-bounce-custom ${isActive("/media")}`}>
            MEDIA
          </Link>
          <Link to="/compliance" className={`hover:text-gray-600 hover:animate-bounce-custom ${isActive("/compliance")}`}>
            COMPLIANCE
          </Link>
          <Link to="/contact-us" className={`hover:text-gray-600 hover:animate-bounce-custom ${isActive("/contact-us")}`}>
            CONTACT US
          </Link>
        </div>

        <button className="md:hidden text-blue-800 text-3xl" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FiX /> : <FiMenu />}
        </button>
      </div>
      {/* .....Mobile Only...... */}
      <div className={`md:hidden bg-[#0b1831] w-full px-6 transition-all duration-300 ${isOpen ? "block" : "hidden"}`}>
        <Link to="/" onClick={closeNavbar} className={`block py-3 hover:bg-gray-700 ${isActivem("/")}`}>
          HOME
        </Link>

        {/* BUSINESS SEGMENT */}
        <div className="py-3 flex justify-between items-center text-white" onClick={() => toggleSubmenu("business-segment")}>
          BUSINESS SEGMENT {openSubmenu === "business-segment" ? <FiChevronUp /> : <FiChevronDown />}
        </div>
        {openSubmenu === "business-segment" && (
          <div className="pl-4 text-gray-300">
            {/* AKT STEEL */}
            <div className="py-3 flex justify-between items-center text-white" onClick={() => toggleNestedSubmenu("akt-steel")}>
              AKT STEEL {openNestedSubmenu === "akt-steel" ? <FiChevronUp /> : <FiChevronDown />}
            </div>
            {/* Under AKT STEEL */}
            {openNestedSubmenu === "akt-steel" && (
              <div className="pl-6 text-gray-400">
                <Link to="/division/structural-divisions" className={`block py-2 hover:text-white ${isActivem("/division/structural-divisions")}`} onClick={closeNavbar}>
                  STEEL STRUCTURE
                </Link>
                <Link to="/division/steel-pipes" className={`block py-2 hover:text-white ${isActivem("/division/steel-pipes")}`} onClick={closeNavbar}>
                  STEEL PIPES
                </Link>
                <Link to="/division/valve-&-flanges" className={`block py-2 hover:text-white ${isActivem("/division/valve-&-flanges")}`} onClick={closeNavbar}>
                  VALVE & FLANGES
                </Link>

                {/* Akt Showroom and Workshops Projects */}
                <div
                  className="py-2 flex justify-between items-center text-white cursor-pointer"
                  onClick={() => toggleThirdLevelSubmenu("akt-showroom")}
                >
                  AKT SHOWROOM & WORKSHOPS PROJECTS
                  {openThirdLevelSubmenu === "akt-showroom" ? <FiChevronUp /> : <FiChevronDown />}
                </div>

                {/* Project Completed submenu */}
                {openThirdLevelSubmenu === "akt-showroom" && (
                  <div className="pl-4 text-gray-400">
                    <Link
                      to="/division/project-completed"
                      className={`block py-2 hover:text-white ${isActivem("/division/project-completed")}`}
                      onClick={closeNavbar}
                    >
                      PROJECTS COMPLETED
                    </Link>
                  </div>
                )}
              </div>
            )}
            {/* AKT TRADING */}
            <div className="py-3 flex justify-between items-center text-white" onClick={() => toggleNestedSubmenu("akt-trading")}>
              AKT TRADING {openNestedSubmenu === "akt-trading" ? <FiChevronUp /> : <FiChevronDown />}
            </div>
            {openNestedSubmenu === "akt-trading" && (
              <div className="pl-6 text-gray-400">

                <Link to="/division/Selment" className={`block py-2 hover:text-white ${isActivem("/division/Selment")}`} onClick={closeNavbar}>
                  SEALENTS
                </Link>
                <Link to="/division/Rtv" className={`block py-2 hover:text-white ${isActivem("/division/Rtv")}`} onClick={closeNavbar}>
                  AIRCRAFT MAINTENANCE (RTV)
                </Link>
                <Link to="/division/Adhesives" className={`block py-2 hover:text-white ${isActivem("/division/Adhesives")}`} onClick={closeNavbar}>
                  ADHESIVES
                </Link>
                {/* <Link to="/division/Roofcoating" className={`block py-2 hover:text-white ${isActivem("/division/Roofcoating")}`} onClick={closeNavbar}>
                  ROOF COATINGS
                </Link> */}
              </div>
            )}

            {/* AKT AUTOMOTIVE */}
            <div className="py-3 flex justify-between items-center text-white" onClick={() => toggleNestedSubmenu("akt-automotive")}>
              AKT AUTOMOTIVE {openNestedSubmenu === "akt-automotive" ? <FiChevronUp /> : <FiChevronDown />}
            </div>
            {openNestedSubmenu === "akt-automotive" && (
              <div className="pl-6 text-gray-400">
                <Link to="/division/akt-car-care" className={`block py-2 hover:text-white ${isActivem("/division/akt-car-care")}`} onClick={closeNavbar}>
                  AKT CAR CARE
                </Link>
                <Link to="/division/akt-car-wash" className={`block py-2 hover:text-white ${isActivem("/division/akt-car-wash")}`} onClick={closeNavbar}>
                  AKT CAR WASH
                </Link>
                <Link to="/division/powder-coating" className={`block py-2 hover:text-white ${isActivem("/division/powder-coating")}`} onClick={closeNavbar}>
                  AKT POWDER COATING
                </Link>
                <Link to="/division/akt-quick-services" className={`block py-2 hover:text-white ${isActivem("/division/akt-quick-services")}`} onClick={closeNavbar}>
                  QUICK SERVICES
                </Link>
              </div>
            )}

            {/* ................. */}

            {/* AKT Tools */}
            <div className="py-3 flex justify-between items-center text-white" onClick={() => toggleNestedSubmenus("akt-tools")}>
              AKT TOOLS DIVISION {openAkttools === "akt-tools" ? <FiChevronUp /> : <FiChevronDown />}
            </div>
            {openAkttools === "akt-tools" && (
              <div className="pl-6 text-gray-400">
                <Link
                  to="/division/akt-tools-division"
                  className={`block py-2 hover:text-white ${isActivem("/division/akt-tools-division")}`}
                  onClick={closeNavbar}
                >
                  AKT TOOLS
                </Link>
              </div>
            )}
          </div>
        )}

        <Link to="/about-us" onClick={closeNavbar} className={`block py-3 ${isActivem("/about-us")}`}>
          ABOUT US
        </Link>
        <Link to="/media" onClick={closeNavbar} className={`block py-3 ${isActivem("/media")}`}>
          MEDIA
        </Link>
        <Link to="/compliance" onClick={closeNavbar} className={`block py-3 ${isActivem("/compliance")}`}>
          COMPLIANCE
        </Link>
        <Link to="/contact-us" onClick={closeNavbar} className={`block py-3 ${isActivem("/contact-us")}`}>
          CONTACT US
        </Link>
        <Link to="#" onClick={closeNavbar} className={`block py-0 ${isActivem("#")}`}>
          &nbsp;
        </Link>
      </div>
    </nav>
  );
}
